<template>
  <v-card>
    <v-card-title>
      Výplaty
    </v-card-title>
    <v-card-actions>
      <v-btn small color="primary" outlined @click="exportCsv">Export CSV</v-btn>
    </v-card-actions>
    <v-card-text>
      <data-search
          @search="getData"
          @input="search = $event"/>
    </v-card-text>
    <v-data-table class="yzz-table"
                  dense
                  :headers="headers"
                  :items="items"
                  :server-items-length="itemsLength"
                  :options.sync="options"
                  :footer-props="footerProps"
                  multi-sort
                  mobile-breakpoint="-1">
      <template #item.createdAt="{ item }">
        {{ formatCreatedAt(item) }}
      </template>
      <template #item.updatedAt="{ item }">
        {{ formatUpdatedAt(item) }}
      </template>
      <template #item.from="{ item }">
        {{ formatFrom(item) }}
      </template>
      <template #item.to="{ item }">
        {{ formatTo(item) }}
      </template>
      <template #item.paidOutDate="{ item }">
        {{ formatPaidOut(item) }}
      </template>
      <template #item.action="{ item }">
        <v-btn v-if="item.status !== 'PAID'" outlined small color="secondary" @click="openPaySalaryDialog(item)">
          Označit jako zaplacené
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog max-width="600" :value="paySalaryDialog" @change="closePaySalaryDialog">
      <v-card>
        <v-card-title>
          Označit plat jako vyplacený
        </v-card-title>
        <v-form @submit.prevent="paySalary">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field hide-details="auto" outlined filled dense v-model="selectedSalaryData.paidOutIban"
                              label="IBAN" hint="Pokud toto pole nevyplníte, použije se výchozí IBAN uživatele"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field hide-details="auto" outlined filled dense v-model="selectedSalaryData.paidOutSwift"
                              label="SWIFT" hint="Pokud toto pole nevyplníte, použije se výchozí SWIFT uživatele"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn small color="primary" class="mx-1" type="submit">Uložit</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import {formatDate, formatDatetime} from '@/helper/date-helper'
import {exportCSVFile, generateRequestParams} from '@/helper/global-helper'

export default {
  name: "UserSalariesTable",
  props: {
    userId: {},
  },
  data() {
    return {
      headers: [
        {text: 'ID', value: 'id'},
        {text: 'Výdelky', value: 'earnings'},
        {text: 'Stav', value: 'status'},
        {text: 'Od', value: 'from'},
        {text: 'Do', value: 'to'},
        {text: 'Vyplaceno', value: 'paidOutDate'},
        {text: 'Vyplaceno na IBAN', value: 'paidOutIban'},
        {text: 'Vyplaceno na SWIFT', value: 'paidOutSwift'},
        {text: 'Aktualizováno', value: 'updatedAt'},
        {text: 'Vytvořeno', value: 'createdAt'},
        {text: 'Akce', value: 'action', sortable: false}
      ],
      options: {
        itemsPerPage: 15
      },
      footerProps: {
        itemsPerPageOptions: [15, 25, 50, 100, 250, 500, 1000]
      },
      data: null,
      search: null,
      selectedSalary: null,
      selectedSalaryData: {
        paidOutSwift: null,
        paidOutIban: null
      }
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    itemsLength() {
      if (!this.data) return 0
      return this.data.totalElements
    },
    items() {
      if (!this.data) return []
      return this.data.content
    },
    paySalaryDialog() {
      return !!this.selectedSalary
    }
  },
  methods: {
    getData() {
      const params = generateRequestParams(
          this.options.page,
          this.options.itemsPerPage,
          this.search,
          this.options.sortBy,
          this.options.sortDesc
      )
      params.append('user', this.userId)
      this.axios.get('/api/admin/salary', {
        params: params
      })
          .then(({data}) => {
            this.data = data
          })
    },
    paySalary() {
      if (!this.selectedSalary) return
      this.axios.put('/api/admin/salary/' + this.selectedSalary.id, null, {
        params: this.selectedSalaryData
      }).then((response) => {
        this.$set(this.data.content, this.data.content.indexOf(this.selectedSalary), response.data.data)
      }).finally(() => {
        this.$nextTick(() => this.closePaySalaryDialog())
      })
    },
    openPaySalaryDialog(item) {
      this.selectedSalary = item
    },
    closePaySalaryDialog(val) {
      if (val) return
      this.selectedSalary = null
      this.selectedSalaryData = {
        paidOutSwift: null,
        paidOutIban: null
      }
    },
    formatCreatedAt({createdAt}) {
      return formatDatetime(createdAt)
    },
    formatUpdatedAt({updatedAt}) {
      if (!updatedAt) return ''
      return formatDatetime(updatedAt)
    },
    formatPaidOut({paidOutDate}) {
      if (!paidOutDate) return ''
      return formatDatetime(paidOutDate)
    },
    formatFrom(item) {
      return formatDate(item['from'])
    },
    formatTo({to}) {
      return formatDate(to)
    },
    exportCsv(){
      exportCSVFile(this.headers, this.items, 'user-salaries')
    }
  },
  watch: {
    options: {
      handler() {
        this.getData()
      },
      deep: true,
    }
  }
}
</script>